export default "__VITE_ASSET__RsHm13g0__"